import type { CSSProperties, FC, ReactNode } from 'react';
import { PDF_BORDER, PDF_HEADER_BACKGROUND_COLOR } from '../constants';

type Props = {
  children: ReactNode;
  style?: CSSProperties;
};

export const Thead: FC<Props> = ({ children, style }) => (
  <thead
    style={{
      display: 'table-header-group',
      breakInside: 'avoid',
      backgroundColor: PDF_HEADER_BACKGROUND_COLOR,
      border: PDF_BORDER.NORMAL,
      boxSizing: 'border-box',
      ...style,
    }}
  >
    {children}
  </thead>
);
